import { Button } from '@mui/material';
import { buttonLinkSX, buttonSX } from '@/components/blocks/DpLibrary/DpButtonEmail/style/main';

export const DpButtonEmail = ({
	label,
	email,
	variant = 'button',
	...props
}: {
	label: string;
	email: string;
	variant?: string;
}) => {
	const mailtoLink = `mailto:${email}`;

	return variant === 'link' ? (
		<Button
			component="a"
			href={mailtoLink}
			target="_blank"
			type="submit"
			variant="contained"
			{...props}
			sx={buttonLinkSX}
		>
			{label}
		</Button>
	) : (
		<Button
			component="a"
			href={mailtoLink}
			target="_blank"
			type="submit"
			variant="contained"
			{...props}
			sx={buttonSX}
		>
			{label}
		</Button>
	);
};
